// Keeping this in user.ts file, because it's part of the /me response
export const KNOWLEDGE_BASE_GENERATION_STATUS = {
  NOT_TRIGGERED: "not_triggered",
  TRIGGERED: "triggered",
  COMPLETED: "completed",
};
